import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppThunkAPIType } from "../../app/appTypes"
import { getWithAuth, postWithAuth, putWithAuth } from "../../http";

export type UserRequestStatus = "NEW" | "CLOSED" | "REJECTED";

export interface UserRequests {
    id: number;
    companyId: number;
    message: string;
    messageType: string;
    status: UserRequestStatus;
    createDate: Date;
    modifyDate: Date | null;
    actionMessage: string | null;
    actionUser: string | null;
    actionDate: Date | null;
}

interface UserRequestPayload {
    id: number;
}

interface CreateUserRequestPayload extends UserRequestPayload {
    message: string;
    messageType: string;
}

interface ActionUserRequestPayload extends UserRequestPayload {
    actionMessage: string;
    status: "CLOSED" | "REJECTED";
    password: string;
}

interface DeleteUserRequestPayload extends UserRequestPayload {
    password: string;
}

export const loadAllUserRequests = createAsyncThunk<UserRequests[], void, AppThunkAPIType>("user-requests/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: "api/user-requests" }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as UserRequests[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadUserRequests = createAsyncThunk<UserRequests[], void, AppThunkAPIType>("user-requests/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: "api/user-requests/user" }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as UserRequests[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createUserRequest = createAsyncThunk<UserRequests, CreateUserRequestPayload, AppThunkAPIType>("user-requests/load", async (userRequest, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: "api/user-requests", payload: { message: userRequest.message, messageType: userRequest.messageType } }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as UserRequests
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateUserRequest = createAsyncThunk<UserRequests, CreateUserRequestPayload, AppThunkAPIType>("user-requests/load", async (userRequest, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/user-requests/edit/${userRequest.id}`, payload: { message: userRequest.message, messageType: userRequest.messageType } }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as UserRequests
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const actionUserRequest = createAsyncThunk<UserRequests, ActionUserRequestPayload, AppThunkAPIType>("user-requests/load", async (userRequest, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/user-requests/action/${userRequest.id}`, payload: { actionMessage: userRequest.actionMessage, status: userRequest.status, password: userRequest.password } }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as UserRequests
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const deleteUserRequest = createAsyncThunk<number, DeleteUserRequestPayload, AppThunkAPIType>("user-requests/load", async (userRequest, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/user-requests/delete/${userRequest.id}`, payload: { password: userRequest.password } }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as number
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})